
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z","fill":"#0B30B2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 7.444a2.333 2.333 0 100 4.667 2.333 2.333 0 000-4.667zM7.665 9.778a4.333 4.333 0 118.667 0 4.333 4.333 0 01-8.667 0zM16.28 18.126a3.445 3.445 0 00-2.058-.682H9.778a3.446 3.446 0 00-3.3 2.454 1 1 0 11-1.916-.576 5.444 5.444 0 015.216-3.878h4.444a5.446 5.446 0 015.218 3.886 1 1 0 01-1.916.573 3.444 3.444 0 00-1.243-1.777z","fill":"#0B30B2"}})])
          )
        }
      }
    